import axios from 'axios';

/** Extract a human-readable message from an axios/unknown error. */
export function errMsg(e: unknown): string {
  if (axios.isAxiosError(e)) {
    return (e.response?.data as { error?: string })?.error ?? e.message;
  }
  return e instanceof Error ? e.message : String(e);
}

/** Split a comma/whitespace/newline separated string into a trimmed list. */
export function splitList(s: string): string[] {
  return s
    .split(/[,\n]/)
    .map((x) => x.trim())
    .filter(Boolean);
}

/**
 * Hinweis nach einer Gast-Einladung ohne Mail. Das Backend schreibt dann
 * `last_error`; beginnt er mit "Keine Einladungs-Mail", ist es KEIN Fehler,
 * sondern Absicht (wiederkehrender Gast mit Anmeldedaten: eine Mail waere ein
 * Passwort-Reset per Postfach, invite-guard.ts im Backend).
 */
export function guestInviteNotice(g: {
  email: string;
  invite_sent: boolean;
  last_error: string | null;
}, bis: string): string {
  // Zwei verschiedene Fristen: der Link gilt hoechstens 24 h (invite-guard.ts),
  // der Gastzugang bis expires_at (bis zu 90 Tage).
  if (g.invite_sent) {
    return `Einladung an ${g.email} verschickt. Der Link gilt höchstens 24 Stunden, der Gastzugang bis ${bis}.`;
  }
  if (g.last_error && g.last_error.startsWith('Keine Einladungs-Mail')) {
    return `Gastzugang für ${g.email} aktiv bis ${bis}. ${g.last_error}`;
  }
  if (!g.last_error) return `Gastzugang für ${g.email} aktiv bis ${bis} (temporäres Passwort, keine Mail).`;
  return `Konto ${g.email} angelegt, aber die Einladungs-Mail kam nicht raus (${g.last_error}).`;
}
